export default __webpack_public_path__ + "static/media/FSEmericWeb-Light.f999380b.woff";